import script from "./Record.vue?vue&type=script&lang=ts&setup=true"
export * from "./Record.vue?vue&type=script&lang=ts&setup=true"

import "./Record.vue?vue&type=style&index=0&id=a618e26a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a618e26a"]])

export default __exports__